import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import useMyInfo from '../auth/useMyInfo';

const useBottomSheetDetails = (goalUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key =
    isLoggedIn && goalUID
      ? `v1/planner/bottom_sheet/details/?goal_uid=${goalUID}`
      : null;

  const { data = {}, ...rest } = useFetch(key, { useCamelCase: false });
  return { data, ...rest };
};

export default useBottomSheetDetails;
